import { EventType } from "./EventType";

/** The answers a guest can give for each time. Matches the AnswerOptions enum in the API. */
export enum AnswerOptions {
    YesNoMaybe = 0,
    /** A sign-up: "Kommer" and "Kommer inte". */
    YesNo = 1,
    /** A sign-up: only "Kommer". */
    Yes = 2
}

/**
 * A sign-up where "Kommer" is the only answer. A time left unanswered is "not coming", and a guest who
 * already is signed up cancels with "Avanmäl mig". Older sign-ups have YesNoMaybe and keep both answers.
 */
export const isOnlyComing = (event: any) =>
    event?.eventType !== EventType.Poll && event?.answerOptions === AnswerOptions.Yes;
